import controller from './node-graph-view.controller';
import template from './node-graph-view.html';

import './node-graph-view.scss';

/** @type {NodeGraphViewer.Bindings} */
const bindings = {
	roots: '<',
	directions: '<',
	name: '@',
};

export default {
	template,
	bindings,
	controller,
	controllerAs: 'ctrl',
};
